<template>
  <div class="talk-list">
    <div class="contentBox">
      <div class="talk-notice" v-show="newTalkCount > 0">
        <div class="new-talk-content">
          <head-image v-for="(talk, index) in newTalkList" :key="index" :url="talk.avatar" :name="talk.nickName" :size="24"></head-image>
          <span class="new-talk-text">{{newTalkCount}}条新动态</span>
        </div>
      </div>
      <div class="sayItem" v-for="(item, index) in talkList" :key="index">
        <head-image :url="item.avatar" :id="item.userId" :name="item.nickName" :size="45"></head-image>
        <div class="rightBox">
          <div class="rightBoxHeader">
            <div class="nickname" :class="{'character-name': item.characterId !== null }">
              {{ item.nickName }}
            </div>
            <div class="talk-info">
              <span class="author" v-if="item.characterId || item.groupTemplateId" @click="showUserInfo($event, item.userId)">By：{{item.authorName}}</span>
              <span class="status" v-if="item.status !== '2'">{{item.statusName}}</span>
            </div>
          </div>
          <p class="content" v-highlight v-html="$emo.transform(item.content)"></p>
          <div v-if="item.fileList && item.fileList.length > 0" class="detail-files">
            <div v-if="getImageFiles(item.fileList).length > 0" :class="['file-image-grid', getImageGridClass(item.fileList)]">
              <div v-for="(file, idx) in getImageFiles(item.fileList)" :key="'img-' + idx" class="image-item" @click="previewImg(file.url, [file.url])">
                <img :src="file.url" />
              </div>
            </div>
            <div v-if="getVideoFile(item.fileList)" class="file-video" @click="playVideo(getVideoFile(item.fileList).url, getVideoFile(item.fileList).coverUrl)">
              <img :src="getVideoFile(item.fileList).coverUrl" class="video-cover" />
              <span class="play-icon-overlay el-icon-video-play"></span>
            </div>
            <div v-if="getAudioFile(item.fileList)" class="file-audio">
              <vue-audio :audio-source="getAudioFile(item.fileList).url"></vue-audio>
            </div>
          </div>
          <div class="bottomBox">
            <div v-if="item.address" class="address">
              <a>
                <i class="el-icon-location-outline"></i> {{ item.address }}
              </a>
            </div>
            <span class="time">
              <a>
                <i class="el-icon-time"></i> {{ formatCreateTime(item.createTime) }}
              </a>
            </span>
            <div class="operate" ref="operate">
              <span class="like" v-if="!item.isLike" @click="sayLike(item)">
                <span class="icon iconfont icon-dianzan1"></span>
              </span>
              <span class="like" v-else @click="cancelLike(item)">
                <span class="icon iconfont icon-dianzan1" style="color: orange;"></span>
              </span>
              <span class="fgx"></span>
              <span class="commentBtn" @click="handleShowCommentBox(null, item.id, index)">
                <i class="el-icon-chat-dot-square"></i> 评论
              </span>
              <span class="delBtn" v-if="item.isOwner">
                <el-popconfirm
                    confirm-button-text='确认'
                    cancel-button-text='取消'
                    icon="el-icon-info"
                    icon-color="red"
                    title="确认删除当前动态吗？"
                    @confirm="delTalk(item, index)"
                >
                  <el-button slot="reference" icon="el-icon-delete-solid" size="mini" circle @click.stop></el-button>
                </el-popconfirm>

              </span>
              <span class="editBtn" v-if="item.isOwner && item.category === category" @click="editTalk(item)">
                <i class="el-icon-edit"></i>
              </span>
              <span class="fgx"></span>
              <span class="setBtn" @click="commentSetDialogOpen(item, index)">
                <i class="el-icon-setting"></i>
              </span>
            </div>
            <a class="operateBtn" @click="handleShowOperate(index)">
              <i class="el-icon-more"></i>
            </a>
          </div>
          <div class="interaction">
            <div v-if="item.talkStarVOS && item.talkStarVOS.length"
                 :class="item.talkStarVOS && item.talkCommentVOS ? 'like-container is_border' : 'like-container'">
              <svg class="icon svg-icon" aria-hidden="true">
                <use xlink:href="#icon-dianzan1"></use>
              </svg>
              <span class="star-user" v-for="(star, user_index) in getVisibleStars(item)" :key="user_index"
                    @click="showUserInfo($event, star.userId)">
                {{ star.nickname }}
                <span v-if="user_index < getVisibleStars(item).length - 1">，</span>
              </span>
              <span v-if="shouldCollapseLikes(item)" class="like-summary" @click="expandLikes(item.id)">
                等{{ item.talkStarVOS.length }}人觉得很赞
              </span>
              <span v-if="shouldShowLikeCollapse(item)" class="like-collapse" @click="collapseLikes(item.id)">
                收起
              </span>
            </div>
            <div class="commentBox">
              <div class="commentItem" v-for="(comment, comment_index) in getVisibleComments(item)"
                   :key="comment_index">
                <div class="comment-content">
                  <span class="comment-meta">
                    <head-image class="comment-avatar" :url="comment.userAvatar" :id="comment.userId" :name="comment.userNickname" :size="24"/>
                    <span class="username" :class="{'character-name': comment.characterId !== null}" @click="showUserInfo($event, comment.userId)">
                        {{ comment.userNickname }}
                    </span>
                    <span class="reply-label" v-if="comment.replyCommentId">回复</span>
                    <head-image v-if="comment.replyCommentId" class="comment-avatar" :url="comment.replyUserAvatar" :id="comment.replyUserId" :name="comment.replyUserNickname" :size="24"/>
                    <span class="username" :class="{'character-name': comment.replyUserCharacterId !== null}" v-if="comment.replyCommentId" @click="showUserInfo($event, comment.replyUserId)">{{ comment.replyUserNickname }}</span>
                    <span>：</span>
                  </span>
                  <span v-if="comment.type === $enums.MESSAGE_TYPE.TEXT" class="content point" v-html="$emo.transform(comment.content)"
                        @click="handleShowCommentBox(comment, item.id, index)">
                  </span>
                  <span v-if="comment.type === $enums.MESSAGE_TYPE.WORD_VOICE" class="content">
                    <span class="word" :title="JSON.parse(comment.content).word" @click="handleShowCommentBox(comment, item.id, index)">{{JSON.parse(comment.content).word}}</span>
                    <span class="icon iconfont icon-xitongxiaoxi" style="color: orange;" @click.stop="playVoice(JSON.parse(comment.content))"></span>
                  </span>
                  <span v-if="comment.type === $enums.MESSAGE_TYPE.IMAGE" class="content">
                    <img :src="JSON.parse(comment.content).originUrl" loading="lazy" @click="handleShowCommentBox(comment, item.id, index)"/>
                  </span>
                  <div class="del-btn" v-if="comment.isOwner">
                    <el-popconfirm
                        confirm-button-text='确认'
                        cancel-button-text='取消'
                        icon="el-icon-info"
                        icon-color="red"
                        title="确认删除当前评论吗？"
                        @confirm="delComment(item, comment.id)"
                    >
                      <el-button slot="reference" size="mini" type="text" @click.stop style="color: #d42e07">删除</el-button>
                    </el-popconfirm>
                  </div>
                </div>
              </div>
              <div class="load-more-comments"
                  v-if="item.talkCommentVOS.length > getVisibleCommentsCount(item.id)"
                  @click="loadMoreComments(item.id)">
                <span class="load-more-text">
                  展开更多评论 ({{ item.talkCommentVOS.length - getVisibleCommentsCount(item.id) }}条)
                </span>
                <i class="el-icon-arrow-down"></i>
              </div>
              <!-- Collapse Comments -->
              <div class="collapse-comments"
                  v-if="getVisibleCommentsCount(item.id) > 5"
                  @click="collapseComments(item.id)">
                <span class="collapse-text">收起评论</span>
                <i class="el-icon-arrow-up"></i>
              </div>
              <input-box ref="contentInputBox" :placeholder="placeholder"
                         @send="(...args) => sayComment(item, ...args)"
                         @sendWord="(...args) => sendCommentWord(item, ...args)"
                         :character-id="item.commentCharacterId"></input-box>
            </div>
          </div>
        </div>
      </div>
      <pagination :totalPage="page.totalPage" :pageNo="page.pageNo" @changePage="handlePage"></pagination>
    </div>
    <add-talk :visible.sync="addTalkVisible"
              v-if="addTalkVisible"
              :category="category"
              :group-id="groupId"
              :region-group-id="regionGroupId"
              :region-code="regionCode"
              :character-id="characterId"
              :group-template-id="groupTemplateId"
              @close="closeAddTalkDialog"
              @refresh="refreshTalkList"
              :talkId="curTalk.id">
    </add-talk>
    <!--    <image-preview :img="images"></image-preview>-->
    <el-dialog title="评论设置"
               :visible.sync="commentSetVisible"
               :before-close="commentSetDialogClose"
               :append-to-body="true"
               width="25%">
      <el-form ref="commentSetForm" label-width="auto"
               :model="commentSetForm" class="form-box">
        <el-form-item label="角色选择：" prop="character" label-width="120px">
          <div style="display: flex;align-items: center;gap: 10px;">
            <span class="character-item" v-on:click="openCharacterChooseDialog">
              <el-avatar fit="fit" size="medium" icon="el-icon-user-solid" :src="commentSetForm.avatar" style="display: flex;align-items: center;justify-content: center;cursor: pointer;"></el-avatar>
            </span>
            <span class="nick-name">{{ commentSetForm.nickName }}</span>
            <el-button @click="removeCharacter" class="del-btn"
                       v-if="commentSetForm.commentCharacterId"
                       type="danger" icon="el-icon-delete"
                       size="mini" circle></el-button>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmCharacter()" size="small">确认</el-button>
        <el-button @click="cancelCharacter()" size="small">取消</el-button>
      </span>
      <template-character-choose
          :visible.sync="chooseCharacterDialogVisible"
          :appendToBody="true"
          @close="closeChooseCharacterDialog"
          @confirm="confirmChooseCharacter">
      </template-character-choose>
    </el-dialog>
    <video-play  ref="videoPlay" :videoUrl="videoUrl" :posterUrl="posterUrl" @close="closeVideoPlay"></video-play>
  </div>
</template>

<script>
import AddTalk from "@/components/talk/AddTalk";
import HeadImage from "@/components/common/HeadImage";
import BatchFileUpload from "@/components/common/BatchFileUpload";
import Avatar from "@/components/common/Avatar";
import Pagination from "@/components/pagination/Pagination";
import TemplateCharacterChoose from "@/components/template/TemplateCharacterChoose";
import Emoji from '@/components/emoji';
import VideoPlay  from "../common/VideoPlay.vue";
import InputBox from "@components/common/InputBox.vue";
/*import ImagePreview from "@/components/imagePreview/ImagePreview";*/

export default {
  name: "FriendActivity",
  components: {
    HeadImage,
    BatchFileUpload,
    AddTalk,
    Avatar,
    Pagination,
    TemplateCharacterChoose,
    Emoji,
    VideoPlay,
    InputBox,
    /*ImagePreview*/
  },
  props: {
    category: {
      type: String,
      required: true
    },
    section: {
      type: String,
      default: ''
    },
    friendId: {
      type: Number,
      default: null,
    },
    groupId: {
      type: Number,
      default: null,
    },
    regionGroupId: {
      type: Number,
      default: null,
    },
    regionCode: {
      type: String,
      default: null,
    },
    characterId: {
      type: Number,
      default: null
    },
    characterIdList: {
      type: Array,
      default: () => {
        return []
      }
    },
    groupTemplateId: {
      type: Number,
      default: null
    },
    newTalkList: {
      type: Array,
      default: () => {
        return []
      }
    },
    newTalkCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      addTalkVisible: false,
      page: {
        pageNo: 1,
        pageSize: 10,
        totalPage: 0,
      },
      talkList: [],
      images: {},
      lastIndex: null,
      curTalk: {},
      curTalkIndex: -1,
      commentSetVisible: false,
      commentSetForm: {
        commentCharacterAvatarId: null,
        commentCharacterId: null,
        nickName: '',
        avatar: '',
      },
      chooseCharacterDialogVisible: false,
      commentLastIndex: null,
      placeholder: "请输入内容",
      comment: {
        replyUserId: null,
        replyUserNickname: null,
        replyCommentId: null,
        talkId: null,
        content: ""
      },
      showCommentBox: false,
      lastEditRange: null,
      showEmoji: false,
      videoUrl: '',
      posterUrl: '',
      visibleCommentsCount: {},
      expandedLikeTalks: {},
      audio: null,
      audioSrc: '',
      playCommentId: null,
      timer: null
    }
  },
  created() {
    if(this.section === 'my-friends' || this.section === 'allCharacters') {
      this.pageQueryTalkList();
    }
  },
  computed: {},
  methods: {
    formatCreateTime(createTime) {
      return createTime ? createTime.substring(0, 16) : '';
    },
    getVisibleStars(talk) {
      const stars = talk.talkStarVOS || []
      return this.expandedLikeTalks[talk.id] || stars.length <= 10 ? stars : stars.slice(0, 5)
    },
    shouldCollapseLikes(talk) {
      return talk.talkStarVOS && talk.talkStarVOS.length > 10 && !this.expandedLikeTalks[talk.id]
    },
    shouldShowLikeCollapse(talk) {
      return talk.talkStarVOS && talk.talkStarVOS.length > 10 && this.expandedLikeTalks[talk.id]
    },
    expandLikes(talkId) {
      this.$set(this.expandedLikeTalks, talkId, true)
    },
    collapseLikes(talkId) {
      this.$set(this.expandedLikeTalks, talkId, false)
    },
    getVisibleComments(talk) {
      const count = this.visibleCommentsCount[talk.id] || 5
      return talk.talkCommentVOS.slice(0, count)
    },
    getVisibleCommentsCount(talkId) {
      return this.visibleCommentsCount[talkId] || 5
    },
    loadMoreComments(talkId) {
      const currentCount = this.visibleCommentsCount[talkId] || 5
      this.$set(this.visibleCommentsCount, talkId, currentCount + 10)
    },
    collapseComments(talkId) {
      this.$set(this.visibleCommentsCount, talkId, 5)
    },
    getImageFiles(fileList) {
      if (!fileList) return [];
      return fileList.filter(f => f.fileType === 1);
    },
    getVideoFile(fileList) {
      if (!fileList) return null;
      return fileList.find(f => f.fileType === 2) || null;
    },
    getAudioFile(fileList) {
      if (!fileList) return null;
      return fileList.find(f => f.fileType === 3) || null;
    },
    getImageGridClass(fileList) {
      const count = this.getImageFiles(fileList).length;
      if (count === 0) return '';
      if (count === 1) return 'cols-1';
      if (count === 2 || count === 4) return 'cols-2';
      return 'cols-3';
    },
    sayComment(talk, sendObj) {
      if (!sendObj) {
        return
      }
      if (sendObj.type === this.$enums.MESSAGE_TYPE.IMAGE) {
        this.comment.content = JSON.stringify(sendObj.content)
      } else {
        this.comment.content = sendObj.content
      }
      let params = {
        talkId: talk.id,
        content: this.comment.content,
        userNickname: talk.commentCharacterName,
        characterId: talk.commentCharacterId,
        avatarId: talk.commentCharacterAvatarId,
        userAvatar: talk.commentCharacterAvatar,
        replyCommentId: this.comment.replyCommentId,
        type: sendObj.type
      }
      this.$http({
        url: "/talk/addTalkComment",
        method: 'post',
        data: params
      }).then((data) => {
        if (data.characterId) {
          talk.commentCharacterId = data.characterId;
          talk.commentCharacterAvatarId = data.avatarId;
          talk.commentCharacterName = data.userNickname;
          talk.commentCharacterAvatar = data.userAvatar;
        }
        talk.talkCommentVOS.push(data);
        this.$message.success("评论成功");
        this.comment = {}
        this.$refs.contentInputBox[this.commentLastIndex].hide();
        this.showCommentBox = false
      }).finally(() => {
        this.placeholder = '请输入内容';
      })
    },
    sendCommentWord(talk, data) {
      if (!data) {
         return
      }
      this.comment.content = JSON.stringify({
        id: data.id,
        templateGroupId: data.templateGroupId,
        characterId: data.characterId,
        characterName: data.characterName,
        word: data.word,
        voice: data.voice
      })
      let params = {
        talkId: talk.id,
        content: this.comment.content,
        userNickname: talk.commentCharacterName,
        characterId: talk.commentCharacterId,
        avatarId: talk.commentCharacterAvatarId,
        userAvatar: talk.commentCharacterAvatar,
        replyCommentId: this.comment.replyCommentId,
        type: this.$enums.MESSAGE_TYPE.WORD_VOICE
      }
      this.$http({
        url: "/talk/addTalkComment",
        method: 'post',
        data: params
      }).then((data) => {
        if (data.characterId) {
          talk.commentCharacterId = data.characterId;
          talk.commentCharacterAvatarId = data.avatarId;
          talk.commentCharacterName = data.userNickname;
          talk.commentCharacterAvatar = data.userAvatar;
        }
        talk.talkCommentVOS.push(data);
        this.$message.success("评论成功");
        this.comment = {}
        this.$refs.contentInputBox[this.commentLastIndex].hide();
        this.showCommentBox = false
      }).finally(() => {
        this.placeholder = '请输入内容';
      })
    },

    showUserInfo(e, userId) {
      if (userId && userId > 0) {
        this.$http({
          url: `/user/find/${userId}`,
          method: 'get'
        }).then((user) => {
          this.$store.commit("setUserInfoBoxPos", e);
          this.$store.commit("showUserInfoBox", user);
        })
      }
    },
    handleShowAddTalk() {
      this.addTalkVisible = true;
    },
    refreshTalkList() {
      this.lastIndex = null;
      this.commentLastIndex = null;
      this.page.pageNo = 1;
      this.page.totalPage = 0;
      this.talkList = [];
      // 清除之前的定时器
      if (this.timer) {
        clearTimeout(this.timer)
      }

      // 设置新的定时器
      this.timer = setTimeout(() => {
        this.pageQueryTalkList();
        this.timer = null
      }, 0) // 使用 0 延迟，确保在下一个事件循环执行
    },
    pageQueryTalkList() {
      if (!this.section) {
        return;
      }
      let friendIds = [];
      if (this.friendId) {
        friendIds.push(this.friendId);
      }
      if (this.section === 'friend' && friendIds.length === 0) {
        return
      }
      if (this.section === 'group' && !this.groupId) {
        return
      }
      if (this.section === 'my-region' && !this.regionGroupId) {
        return
      }
      if (this.section === 'region' && !this.regionCode) {
        return
      }
      if (this.section === 'character' && !this.characterId) {
        return;
      }
      if ((this.section === 'groupTemplate' || this.section === 'groupTemplate-characters') && !this.groupTemplateId) {
        return;
      }
      if (this.section === 'characters' && !this.characterIdList.length) {
        return;
      }
      let params = {
        category: this.category,
        section: this.section,
        groupId: this.groupId,
        regionGroupId: this.regionGroupId,
        regionCode: this.regionCode,
        friendIds: friendIds,
        characterId: this.characterId,
        groupTemplateId: this.groupTemplateId,
        characterIds: this.characterIdList,
      }
      this.$http({
        url: `/talk/pageQueryTalkList?pageNo=${this.page.pageNo}&pageSize=${this.page.pageSize}`,
        method: "post",
        data: params
      }).then((data) => {
        this.talkList.push(...data.data)
        this.page.totalPage = (data.total - 1) / this.page.pageSize + 1;
      })
    },
    handlePreviewImg(imgs) {
      this.images = {
        urls: imgs,
        time: new Date().getTime()
      }
    },
    previewImg(img, imgUrls) {
      this.$imagePreview({
        images: imgUrls,
        index: imgUrls.indexOf(img)
      });
    },
    handlePage(pageNo) {
      this.page.pageNo = pageNo;
      this.pageQueryTalkList();
    },
    handleShowOperate(index) {
      if (this.lastIndex != null && this.lastIndex != index) {
        this.$refs.operate[this.lastIndex].style.display = "none"
      }
      if (this.lastIndex == index) {
        if (this.$refs.operate[index].style.display == "block") {
          this.$refs.operate[index].style.display = "none"
        } else {
          this.$refs.operate[index].style.display = "block"
        }
      } else {
        this.$refs.operate[index].style.display = "block"
      }
      this.lastIndex = index
    },
    sayLike(talk) {
      let params = {
        talkId: talk.id,
        nickname: talk.commentCharacterName,
        characterId: talk.commentCharacterId,
        avatarId: talk.commentCharacterAvatarId,
        avatar: talk.commentCharacterAvatar,
      }
      this.$http({
        url: "/talk/like",
        method: 'post',
        data: params
      }).then((data) => {
        talk.isLike = true
        if (data.characterId) {
          talk.commentCharacterId = data.characterId;
          talk.commentCharacterName = data.nickname;
          talk.commentCharacterAvatar = data.avatar;
          talk.commentCharacterAvatarId = data.avatarId;
        }
        talk.talkStarVOS.push(data);
        this.$message.success("点赞成功");
      }).finally(() => {

      })
    },
    cancelLike(talk) {
      let params = {
        talkId: talk.id
      }
      //let userId = this.$store.state.userStore.userInfo.id;
      this.$http({
        url: "/talk/cancelLike",
        method: 'post',
        data: params
      }).then((data) => {
        talk.isLike = false;
        //talk.commentCharacterId = null;
        //talk.commentCharacterName = null;
        //talk.commentCharacterAvatar = null;
        talk.talkStarVOS = talk.talkStarVOS.filter(function (item) {
          return !item.isOwner;
        });
        this.$message.success("取消成功");
      }).finally(() => {

      })
    },
    delTalk(talk, index) {
      this.$http({
        url: "/talk/delete",
        method: 'delete',
        data: {id: talk.id}
      }).then((data) => {
        this.$message.success("删除成功");
        //this.talkList.splice(index, 1);
        this.refreshTalkList();
        this.lastIndex = null;
      }).finally(() => {

      })
    },
    editTalk(talk) {
      this.curTalk = talk;
      this.addTalkVisible = true;
    },
    closeAddTalkDialog() {
      this.addTalkVisible = false;
      this.curTalk = {};
    },
    delBtn(e) {
      e.stopPropagation();
    },
    commentSetDialogOpen(talk, index) {
      this.commentSetForm.nickName = talk.commentCharacterName ? talk.commentCharacterName : talk.commentUserNickname;
      this.commentSetForm.avatar = talk.commentCharacterAvatar ? talk.commentCharacterAvatar : talk.commentUserAvatar;
      this.commentSetForm.commentCharacterId = talk.commentCharacterId;
      this.commentSetForm.commentCharacterAvatarId = talk.commentCharacterAvatarId;
      this.curTalk = talk;
      this.curTalkIndex = index;
      this.commentSetVisible = true;
    },
    commentSetDialogClose() {
      this.commentSetVisible = false;
      this.commentSetForm.nickName = '';
      this.commentSetForm.avatar = '';
      this.commentSetForm.commentCharacterId = null;
      this.commentSetForm.commentCharacterAvatarId = null;
      this.curTalk = {};
      this.curTalkIndex = -1;
    },
    openCharacterChooseDialog() {
      this.chooseCharacterDialogVisible = true;
    },
    removeCharacter() {
      this.commentSetForm.commentCharacterId = null;
      this.commentSetForm.nickName = '';
      this.commentSetForm.avatar = '';
    },
    resetCommentCharacter() {
      this.commentSetForm.commentCharacterId = null;
      this.commentSetForm.nickName = '';
      this.commentSetForm.avatar = '';
    },
    closeChooseCharacterDialog() {
      this.chooseCharacterDialogVisible = false;
    },
    confirmChooseCharacter(resultData) {
      if (resultData?.characterAvatar?.id) {
        this.commentSetForm.commentCharacterAvatarId = resultData.characterAvatar.id;
        this.commentSetForm.nickName = resultData.characterAvatar.level === 0 ? resultData.templateCharacter.name : resultData.characterAvatar.name;
        this.commentSetForm.avatar = resultData.characterAvatar.avatar;
        this.commentSetForm.commentCharacterId = resultData.templateCharacter.id;
      } else {
        this.commentSetForm.nickName = resultData.templateCharacter.name;
        this.commentSetForm.avatar = resultData.templateCharacter.avatar;
        this.commentSetForm.commentCharacterId = resultData.templateCharacter.id;
      }

      this.chooseCharacterDialogVisible = false;
    },
    confirmCharacter() {
      // if (this.curTalk.commentCharacterId && this.commentSetForm.commentCharacterId) {
      //   if (this.curTalk.commentCharacterId !== this.commentSetForm.commentCharacterId) {
      //     this.$message.warning("不能更改评论角色");
      //     return false;
      //   }
      // }
      this.talkList[this.curTalkIndex].commentCharacterId = this.commentSetForm.commentCharacterId;
      this.talkList[this.curTalkIndex].commentCharacterAvatar = this.commentSetForm.avatar;
      this.talkList[this.curTalkIndex].commentCharacterName = this.commentSetForm.nickName;
      this.talkList[this.curTalkIndex].commentCharacterAvatarId = this.commentSetForm.commentCharacterAvatarId;
      this.resetCommentCharacter();
      this.curTalk = {};
      this.curTalkIndex = -1;
      this.commentSetVisible = false;
    },
    cancelCharacter() {
      this.resetCommentCharacter();
      this.curTalk = {};
      this.curTalkIndex = -1;
      this.commentSetVisible = false;
    },
    handleShowCommentBox(comment, talkId, index) {
      //let userId = this.$store.state.userStore.userInfo.id;
      if (comment && comment.isOwner) {
        this.$message.warning("不能回复自己的评论");
        return false;
      }
      if (this.commentLastIndex != null && this.commentLastIndex != index) {
        this.$refs.contentInputBox[this.commentLastIndex].hide();
      }
      if (this.commentLastIndex == index) {
        if (this.$refs.contentInputBox[index].show) {
          this.$refs.contentInputBox[index].hide();
        } else {
          this.$refs.contentInputBox[index].view();
        }
      } else {
        this.$refs.contentInputBox[index].view();
      }
      this.commentLastIndex = index

      if (comment) {
        this.placeholder = "回复" + comment.userNickname + ":"
        this.comment.replyUserId = comment.userId
        this.comment.replyUserNickname = comment.userNickname
        this.comment.replyCommentId = comment.id
      } else {
        this.comment.replyUserId = null
        this.comment.replyUserNickname = null
        this.comment.replyCommentId = null
        this.placeholder = "请输入内容"
      }
      this.comment.talkId = talkId
      this.showCommentBox = !this.showCommentBox
    },
    delComment(talk, commentId) {
      this.$http({
        url: `/talkComment/delete/${commentId}`,
        method: 'delete'
      }).then((data) => {
        talk.talkCommentVOS = talk.talkCommentVOS.filter(function (item) {
          return item.id !== commentId;
        });
        this.$message.success("删除成功");
      }).finally(() => {

      })
    },
    playVideo(videoUrl, coverImageUrl) {
      this.videoUrl = videoUrl;
      this.posterUrl = coverImageUrl;
      this.$refs.videoPlay.onPlayVideo()
    },
    closeVideoPlay() {
      this.videoUrl = '';
      this.posterUrl = '';
    },
    playVoice(word) {
      // 如果当前有正在播放的 audio，先清理
      if (this.audio) {
        this.audio.pause();
        this.audio = null;
        this.audioSrc = '';
      }
      
      this.audio = new Audio();
      this.audioSrc = word.voice;
      this.audio.src = word.voice;
      
      // 监听播放完成事件
      const handleEnded = () => {
        if (this.audio) {
          this.audio.pause();
          this.audio = null;
          this.audioSrc = '';
        }
        // 移除事件监听器
        if (this.audio) {
          this.audio.removeEventListener('ended', handleEnded);
        }
      };
      
      // 添加 ended 事件监听
      this.audio.addEventListener('ended', handleEnded);
      
      // 开始播放
      this.audio.play().catch(err => {
        console.error('音频播放失败:', err);
        // 播放失败时清理
        if (this.audio) {
          this.audio = null;
          this.audioSrc = '';
        }
      });
    }
  },
  watch: {
    
  },
  beforeDestroy() {
    // 组件销毁时清除定时器
    if (this.timer) {
      console.log("TalkList clearTimeout");
      clearTimeout(this.timer)
    }
    
    // 组件销毁时清理 audio 资源
    if (this.audio) {
      this.audio.pause();
      this.audio = null;
      this.audioSrc = '';
      console.log("TalkList audio cleared");
    }
  }
}
</script>

<style scoped lang="scss">
.talk-list {

  .contentBox {
    width: 72%;
    margin: 20px auto;

    .talk-notice {
      display: flex;
      justify-content: center;
      align-items: center;

      .new-talk-content {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 16px;
        background-color: #f5f5f5;
        border-radius: 20px;
        cursor: pointer;

        .new-talk-text {
          font-size: 14px;
          color: red;
          margin-left: 5px;
        }
      }
    }

    .sayItem {
      padding: 15px;
      display: flex;
      margin-bottom: 15px;
      border-radius: 10px;
      position: relative;
      overflow: hidden;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;
      border: 1px solid rgba(0, 0, 0, 0.03);

      &:hover {
        //transform: translateY(-3px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
      }

      .avatar {
        img {
          vertical-align: top;
        }
      }

      .rightBox {
        padding-left: 10px;
        display: flex;
        flex-direction: column;
        width: 100%;

        .rightBoxHeader {
          display: flex;
          justify-content: space-between;
        }

        .nickname {
          text-align: left;
        }

        .character-name {
          color: #f56c6c;
        }

        .talk-info {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 13px;

          .author {
            color: #909399;
            cursor: pointer;
          }

          .status {
            color: #409eff;
          }
        }

        .content {
          text-align: left;
          margin-top: 10px;
          white-space: pre-wrap;
        }

        .detail-files {
          margin-top: 4px;
        }

        .file-image-grid {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;

          .image-item {
            overflow: hidden;
            border-radius: 8px;
            cursor: pointer;
            transition: transform 0.2s;

            &:hover {
              transform: scale(1.02);
            }

            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          &.cols-1 {
            .image-item {
              max-width: 400px;
              /*width: 100%;*/
              border-radius: 10px;

              img {
                width: 100%;
                height: auto;
                object-fit: contain;
                max-height: 400px;
              }
            }
          }

          &.cols-2 {
            .image-item {
              width: calc(50% - 4px);
              aspect-ratio: 1 / 1;

              img {
                height: 100%;
                object-fit: cover;
              }
            }
          }

          &.cols-3 {
            .image-item {
              width: calc(33.333% - 6px);
              aspect-ratio: 1 / 1;

              img {
                height: 100%;
                object-fit: cover;
              }
            }
          }
        }

        .file-video {
          position: relative;
          display: inline-block;
          cursor: pointer;
          border-radius: 8px;
          overflow: hidden;
          max-width: 400px;
          width: 100%;

          .video-cover {
            width: 100%;
            display: block;
            aspect-ratio: 16 / 9;
            object-fit: cover;
          }

          .play-icon-overlay {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 60px;
            color: #fff;
            text-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
            transition: transform 0.2s, font-size 0.2s;
          }

          &:hover .play-icon-overlay {
            font-size: 70px;
          }
        }

        .file-audio {
          max-width: 500px;
          margin-top: 8px;
        }

        .bottomBox {
          margin-top: 20px;
          position: relative;
          display: flex;
          flex-direction: column;

          .address {
            display: flex;
            margin-right: auto;
            color: #5597bd;
            margin-bottom: 10px;
            font-size: 14px;
          }

          .time {
            display: flex;
            margin-right: auto;
            font-size: 14px;
          }

          .operateBtn {
            position: absolute;
            right: 20px;
            bottom: 0;
            display: inline-block;
            padding: 0 5px;
            cursor: pointer;
            font-size: 20px;
            font-weight: bold;
          }

          .operate {
            position: absolute;
            right: 55px;
            bottom: -8px;
            background-color: #4b5153;
            padding: 8px;
            border-radius: 5px;
            display: none;

            &::after {
              content: '';
              position: absolute;
              right: -15px;
              bottom: 10px;
              width: 0;
              height: 0;
              border-width: 8px;
              border-style: solid;
              border-color: transparent transparent transparent #4b5153;
            }

            span {
              padding: 0 10px;
              color: #fff;
              position: relative;
              cursor: pointer;

              &:hover {
                color: #f56c6c;
              }
            }

            .like::after {
              content: "";
              width: 2px;
              height: 100%;
              background-color: #373d40;
              position: absolute;
              right: 0;
            }
          }
        }

        .interaction {
          background-color: #ffffff;
          margin-top: 15px;
          border-radius: 5px;

          .like-container {
            display: flex;
            align-items: center;
            justify-content: left;
            flex-wrap: wrap;

            .icon {
              margin-right: 5px;
              display: block;
              height: 20px;
              line-height: 20px;
              font-size: 18px;
              -webkit-transition: font-size 0.25s linear, width 0.25s linear;
              -moz-transition: font-size 0.25s linear, width 0.25s linear;
              transition: font-size 0.25s linear, width 0.25s linear;
            }

            .star-user {
              cursor: pointer;
            }

            .like-summary,
            .like-collapse {
              cursor: pointer;

              &:hover {
                text-decoration: underline;
              }
            }

            .like-collapse {
              margin-left: 6px;
            }

            span {
              font-size: 14px;
              color: #576b95;
            }
          }

          .is_border {
            border-bottom: 1px dashed rgb(126, 120, 120);
          }

          .commentBox {
            .commentItem {
              text-align: left;
              margin-bottom: 5px;
              position: relative;

              .comment-content {
                display: flex;
                align-items: flex-end;

                .comment-meta {
                  display: inline-flex;
                  align-items: flex-end;
                  flex: 0 0 auto;
                  white-space: nowrap;
                }

                .reply-label {
                  margin: 0 5px;
                }

                .nick-name {
                  color: #f56c6c;
                }
              }

              .comment-avatar {
                display: inline-block;
              }

              &:first-child {
                margin-top: 10px;
              }

              .username {
                cursor: pointer;
              }

              .content {
                cursor: pointer;
                flex: 1 1 auto;
                min-width: 0;
                overflow-wrap: anywhere;

                img {
                  max-width: 180px;
                  max-height: 180px;
                  object-fit: cover;
                }
              }

              .del-btn {
                color: #d42e07;
                font-size: 12px;
                flex: 0 0 auto;
                margin-left: 8px;
              }
            }

            .load-more-comments,
            .collapse-comments {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 8px;
              color: #409eff;
              cursor: pointer;
              font-size: 13px;
              border-top: 1px solid #f0f0f0;
              margin-top: 8px;
            }

            .load-more-comments:hover,
            .collapse-comments:hover {
              background-color: #f8f9fa;
            }

            .load-more-text,
            .collapse-text {
              margin-right: 4px;
            }
          }
        }
      }
    }
  }
}

</style>
